<template>
  <table class="w-full text-sm">
    <thead class="uppercase tracking-wide text-base-content/70">
      <tr>
        <th class="pb-2 text-left">{{ $t("pricing.plan") }}</th>
        <th class="pb-2 text-left">{{ $t("pricing.features") }}</th>
        <th class="pb-2 text-right">{{ $t("pricing.price") }}</th>
      </tr>
    </thead>
  </table>
</template>
